import { Component, OnInit } from '@angular/core';
import { CustomerBillService, CustomerBillFilter, CustomerBillId } from '../../services/customer-bill.service';
import { IncomedBill, IncomeService, IncomeData } from '../../services/income.service';
import { PermissionService, SpecialPermissions } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Utils } from '../../util';
import { toast } from 'angular2-materialize';

interface Data{
  customerName: string;
  date: string;
  folio: string;
  payMethod: string;
  moneyBill: string;
  moneyBillResidue: string;
  moneyNote: string;
  moneyIncome: string;

  datas?: Data[];
}

@Component({
  selector: 'app-transaction-report',
  templateUrl: './transaction-report.component.html',
  styleUrls: ['./transaction-report.component.css']
})

export class TransactionReportComponent implements OnInit {
  allowed: boolean = false;
  permission: Partial<{[K in keyof typeof SpecialPermissions]: boolean}> = {};

  customerBills: Data[] = [];
  creditNotes: Data[] = [];
  incomes: Data[] = [];
  filteredData: Data[] = [];

  constructor(
    private service: CustomerBillService,
    private incomeService: IncomeService,
    private incomeData: IncomeData,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router,
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
        if(!this.permission || !this.permission.customersTransactionReport){
          toast('No tiene permisos.', 3000);
          this.router.navigate(['/']);
        }
        else this.allowed = true;
    });

    let billSub = this.service.getCustomerBills().subscribe(tempCustomerBills => {
      billSub.unsubscribe();
      let incomeSub = this.incomeService.getIncomes().subscribe(incomes => {
        incomeSub.unsubscribe();

        this.customerBills = tempCustomerBills.map( ({id, ...customerBill}: CustomerBillId | any) => {
          let incomed = new IncomedBill({id, ...customerBill});
          customerBill.customerName = customerBill.customerObj.name;
          customerBill.residue = incomed.residue;
          customerBill.payMethod = '';
          customerBill.moneyBillResidue = this.money(customerBill.residue);
          customerBill.moneyBill = this.money(customerBill.totals.total);

          customerBill.datas = [
            ...customerBill.creditNotes.map(cn => ({
              customerName: customerBill.customerName,
              date: cn.date,
              folio: cn.folio || '',
              payMethod: '',
              moneyBill: '',
              moneyBillResidue: '',
              moneyNote: `${this.money(cn.total)}`,
              moneyIncome: ''
            }) ),
            ...incomes.filter( ({bills}) => bills.some( ({customerBillId: cbId}) => cbId == id ) ).map( income => ({
              customerName: income.customerObj.name,
              date: income.date,
              folio: '',
              payMethod: this.incomeData.statusObjects[income.payMethod].name,
              moneyBill: '',
              moneyBillResidue: '',
              moneyNote: '',
              moneyIncome: `${this.money(income.bills.find( ({customerBillId: cbId}) => cbId == id ).amount)}`
            }) )
          ].sort( ({date}, {date: date2}) => date < date2 ? 1 : -1 );

          return customerBill;
        });
        console.log(this.customerBills);

        this.filterBar = new CustomerBillFilter([...this.customerBills], {dateIndex: 3});
        this.applyFilterBar();
      });
    });
  }

  ngOnInit() {
  }


  money = Utils.money;

  ////////////////////////////////////////////////////////////////////FilterBar
  filterBar: CustomerBillFilter = new CustomerBillFilter([], {});
  applyFilterBar(){
    this.filteredData = this.filterBar.filteredData.sort( ({date}, {date: date2}) => date < date2 ? 1 : -1 );
  }
  ////////////////////////////////////////////////////////////////////FilterBar

}
